import { isStaging } from '../../utils/isStaging';

export default function StagingBanner() {
  if (!isStaging()) return null;

  return (
    <div className="bg-orange-400 text-black text-center py-2 font-semibold z-50 shadow-md">
      ⚠️ TESTING MODE: Data shown here is for testing only.
    </div>
  );
}